import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function UpsellSection() {
  const modules = [{
    icon: '🗄️',
    title: 'Bases de datos simples',
    desc: 'Cómo almacenar y consultar información en programas reales'
  }, {
    icon: '🌐',
    title: 'APIs explicadas fácil',
    desc: 'Qué son, para qué sirven y cómo conectar un programa al mundo'
  }, {
    icon: '🤖',
    title: 'Automatización básica',
    desc: 'Scripts simples que resuelven tareas repetitivas reales'
  }, {
    icon: '🧠',
    title: 'Inteligencia Artificial',
    desc: 'Introducción al nivel técnico escolar: conceptos y aplicaciones reales'
  }, {
    icon: '💼',
    title: 'Programación y mundo laboral',
    desc: 'Cómo conectar lo que el alumno aprendió con la demanda real del mercado'
  }];
  return <section className="py-6 md:py-12 px-3 bg-brand-dark" data-id="element-321">
      <div className="max-w-3xl mx-auto" data-id="element-322">
        <div className="text-center mb-5" data-id="element-323">
          <h2 className="text-xl md:text-3xl font-black text-white mb-2" data-id="element-324">
            🔥 ¿QUÉ AGREGA EL UPSELL?
          </h2>
          <p className="text-base md:text-xl font-black text-brand-accent neon-glow" data-id="element-325">
            💣 PROGRAMACIÓN APLICADA AL MUNDO REAL
          </p>
        </div>

        <div className="bg-brand-card rounded-xl border-2 border-brand-accent p-4 md:p-6 shadow-[0_0_20px_rgba(34,197,94,0.15)] max-w-2xl mx-auto" data-id="element-326">
          <div className="space-y-2.5" data-id="element-327">
            {modules.map((mod, i) => <div key={i} className="flex items-start gap-3 p-2.5 rounded-lg bg-brand-dark border border-white/5" data-id="element-328">
                <span className="text-xl shrink-0" data-id="element-329">{mod.icon}</span>
                <div data-id="element-330">
                  <h3 className="text-sm md:text-base font-bold text-white" data-id="element-331">
                    {mod.title}
                  </h3>
                  <p className="text-xs md:text-sm text-gray-400" data-id="element-332">{mod.desc}</p>
                </div>
              </div>)}
          </div>
        </div>

        <div className="text-center mt-5" data-id="element-333">
          <p className="text-sm md:text-lg font-black text-white bg-brand-card inline-block px-4 py-2.5 rounded-lg border border-white/10" data-id="element-334">
            👉 Ideal para llevar a tus alumnos al{' '}
            <span className="text-brand-accent neon-glow" data-id="element-335">
              SIGUIENTE NIVEL REAL
            </span>
          </p>
        </div>
      </div>
    </section>;
}